import { Link } from 'react-router-dom';
import { categories, CategoryInfo } from '@/mocks/categories';

const categoryColors: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-900',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">海量影视资源，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat: CategoryInfo) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group relative bg-background-50 rounded-lg p-6 md:p-8 cursor-pointer transition-all duration-300 hover:scale-[1.02] border border-background-200/70"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center mb-4 ${categoryColors[cat.color] || 'bg-primary-100 text-primary-700'}`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-2">
                {cat.label}
              </h3>
              <p className="text-sm text-foreground-500">{cat.description}</p>
              <div className="mt-4 flex items-center gap-1 text-sm text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                浏览全部 <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}